import { render, staticRenderFns } from "./HomeNavigationSliderItem.vue?vue&type=template&id=5bf63aa9&scoped=true&"
import script from "./HomeNavigationSliderItem.vue?vue&type=script&lang=js&"
export * from "./HomeNavigationSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeNavigationSliderItem.vue?vue&type=style&index=0&id=5bf63aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf63aa9",
  null
  
)

export default component.exports